import { put, takeEvery, call } from "redux-saga/effects";

import topSponsoredEventService from "../../services/topSponsoredEvent";
import {
  getTopSponsoredEventStart,
  getTopSponsoredEventSuccess,
  getTopSponsoredEventFailure
} from "../../redux/topSponsoredEvent";
import { showErrorMessage } from "../../../redux-saga/redux/toast";

function* topSponsoredEventWatcher() {
  yield takeEvery(getTopSponsoredEventStart.type, topSponsoredEventWorker);
}

function* topSponsoredEventWorker(action) {
  try {
    const { data, error } = yield call(
      topSponsoredEventService.getTopSponsoredEvent,
      action.payload
    );
    if (data) {
      yield put(getTopSponsoredEventSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getTopSponsoredEventFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error }));
    yield put(getTopSponsoredEventFailure());
  }
}

export default topSponsoredEventWatcher;
